/**
 * Gate links (spec §4.1, §5.1, K-8). Every events action on kgob.com is a plain <a> to the gate with ONE
 * URL-encoded `to` value, so a target's own `?e=…&s=…` survives as part of `to`. The gate path is the backend
 * route `/api/events/go` unless the site sets REACT_APP_EVENTS_GATE_PATH (`/events/go` once a Cloudflare rule
 * forwards it). No host names, no secrets: app.kgob.com never appears in the HTML.
 */
export const GATE_PATH = process.env.REACT_APP_EVENTS_GATE_PATH || "/api/events/go";

export const gateLink = (target) => `${GATE_PATH}?to=${encodeURIComponent(target)}`;

export const rsvpTarget = (slug, eventSessionId) => `/events/rsvp?e=${encodeURIComponent(slug)}&s=${encodeURIComponent(eventSessionId)}`;

export const links = {
  all: gateLink("/events"),
  past: gateLink("/events/past"),
  my: gateLink("/events/my"),
};

/** Is `href` one of our gate links? (The transition overlay only fires for these.) */
export const isGateHref = (href) => typeof href === "string" && href.startsWith(`${GATE_PATH}?`);

export const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const isSlug = (s) => typeof s === "string" && s.length <= 120 && SLUG_RE.test(s);
export const EVENT_SESSION_ID_RE = /^[A-Za-z0-9._~-]+$/;

/**
 * The old-URL targets (§5.6, K-14) as the module maps them client-side. Anything under /events/my keeps its
 * path when it is made of safe segments; a dot segment ("..") would resolve elsewhere, so it falls back to /events/my.
 */
export function myTarget(rest) {
  const clean = (rest || "").replace(/^\/+|\/+$/g, "");
  if (!clean) return "/events/my";
  if (clean.length > 400 || !/^[A-Za-z0-9._~-]+(?:\/[A-Za-z0-9._~-]+)*$/.test(clean) || /(^|\/)\.\.?(\/|$)/.test(clean)) return "/events/my";
  return `/events/my/${clean}`;
}

/** Full-page navigation to an external (non-router) URL. A named function so tests can spy on it. */
export function leaveTo(url) {
  window.location.replace(url);
}
